import { Injectable } from '@angular/core';
import { BaseContentService } from './base-content-service';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { Observable } from 'rxjs';
import { RequestAccessContent } from './def/request-access-content';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';

@Injectable({
  providedIn: 'root'
})
export class RequestAccessContentService extends BaseContentService<
  RequestAccessContent
> {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService
  ) {
    super(http, configService, RequestAccessContentService.requestAccessData);
  }

  get data$(): Observable<RequestAccessContent> {
    if (!this.loaded) {
      return this.getRequestAccessData();
    }

    return of(this.data);
  }

  getRequestAccessData(): Observable<RequestAccessContent> {
    const url = `${this.serviceBaseUrl}requestaccess`;
    return this.get<RequestAccessContent>(url).pipe(
      map(data => {
        this.data = this.requestAccessMapper(data);
        this.loaded = true;
        return this.data;
      }),
      catchError(this.handleError)
    );
  }

  private requestAccessMapper(
    data: RequestAccessContent
  ): RequestAccessContent {
    if (!data) return;

    return data;
  }
  // getStateData(): Observable<any> {
  //   const url =
  //     'https://dev.artisanedge.com/api/sitecore/ArtisanEdgeDataServices/GetStates';
  //   return this.get(url);
  // }

  private static requestAccessData: RequestAccessContent = {
    pageName: 'requestaccess',
    forms: [
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                },
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: [
                {
                  key: '',
                  value: ''
                },
                {
                  key: '',
                  value: ''
                }
              ]
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: true,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: true,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          }
        ]
      },
      {
        formName: '',
        isAdvanceSearch: false,
        fields: [
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '0',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: 'city',
              label: '',
              fieldType: '',
              fieldID: 'city',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          },
          {
            colClass: '',
            isDisabled: false,
            isVisible: false,
            isAdvanceSearch: false,
            orderId: null,
            fieldInfo: {
              fieldName: '',
              label: '',
              fieldType: '',
              fieldID: '',
              fieldValue: '',
              showLabel: false,
              labelOnly: false,
              required: false,
              fieldLength: null,
              minChar: null,
              maxChar: null,
              decimal: null,
              pattern: '',
              allowDash: false,
              validations: []
            },
            config: null
          }
        ]
      }
    ],
    data: [
      {
        heading: '',
        title: '',
        description: '',
        text: '',
        image: null,
        displayItems: []
      }
    ],
    tabLabels: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    buttons: [
      {
        keyText: ''
      }
    ],
    states: [
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ' '
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ' '
      },
      {
        key: '',
        value: ' '
      },
      {
        key: '',
        value: ' '
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ' '
      },
      {
        key: '',
        value: ''
      },
      {
        key: '',
        value: ''
      }
    ],
    dropdown: []
  };
}
